import React from 'react';
import { Grid, Select, MenuItem } from '@material-ui/core';
import { BiFirstPage } from 'react-icons/bi';
import { BiChevronLeft } from 'react-icons/bi';
import { BiChevronRight } from 'react-icons/bi';
import { BiLastPage } from 'react-icons/bi';

const PageControllBar = ({
    title,
    rowPerPage,
    handleSelectRowPerPageChange,
    handleSetPage,
    firstIndexOfShown,
    knowledgeToShow,
}) => {
    return (
        <Grid container>
            <Grid item md={6} xs={12} />
            <Grid item md={6} xs={12}>
                <Grid container style={{ display: 'flex', alignItems: 'center' }}>
                    <Grid item xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
                        <Select value={rowPerPage} onChange={handleSelectRowPerPageChange}>
                            <MenuItem key={'roll_per_page_15'} value={15}>
                                15 Rows
                            </MenuItem>
                            <MenuItem key={'roll_per_page_30'} value={30}>
                                30 Rows
                            </MenuItem>
                            <MenuItem key={'roll_per_page_50'} value={50}>
                                50 Rows
                            </MenuItem>
                        </Select>
                    </Grid>
                    <Grid item xs={1} style={{ display: 'flex', justifyContent: 'center' }}>
                        <span onClick={() => handleSetPage(title, 'first_page')}>
                            <BiFirstPage size={20} />
                        </span>
                    </Grid>
                    <Grid item xs={1} style={{ display: 'flex', justifyContent: 'center' }}>
                        <span onClick={() => handleSetPage(title, 'previous_page')}>
                            <BiChevronLeft size={20} />
                        </span>
                    </Grid>
                    <Grid item xs={3} style={{ display: 'flex', justifyContent: 'center' }}>
                        <h5>
                            {firstIndexOfShown + 1}-
                            {compareFunc(firstIndexOfShown + rowPerPage, knowledgeToShow.flat().length)} of{' '}
                            {knowledgeToShow.flat().length}{' '}
                        </h5>
                    </Grid>
                    <Grid item xs={1} style={{ display: 'flex', justifyContent: 'center' }}>
                        <span onClick={() => handleSetPage(title, 'next_page')}>
                            <BiChevronRight size={20} />
                        </span>
                    </Grid>
                    <Grid item xs={1} style={{ display: 'flex', justifyContent: 'center' }}>
                        <span onClick={() => handleSetPage(title, 'last_page')}>
                            <BiLastPage size={20} />
                        </span>
                    </Grid>
                </Grid>
            </Grid>
            {/* <Grid item md={2} xs={12} /> */}
        </Grid>
    );
};

const compareFunc = (a, b) => {
    return parseInt(a) < parseInt(b) ? a : b;
};

export default PageControllBar;
